import { isoToFormatDate } from "../../functions/formatTime";
import Row from "../common/List/Row";
import { getProgressText } from "../../functions/problem";

const ProblemRow = ({ problem, setCurProblem, setShowPopUp }) => {
  const user = problem.reporterId;

  const showPopUp = () => {
    setCurProblem(problem);
    setShowPopUp(true);
  };

  const cellTexts = [
    isoToFormatDate(problem.createdAt, "yyyy/MM/dd HH:mm"),
    user?.memberNumber,
    user?.name,
    user?.roomNumber,
    problem.title,
    getProgressText(problem.progress),
  ];

  const noteTexts = [problem.description, problem.note];

  const cellAlign = ["C", "C", "C", "C", "L"];

  return (
    <Row
      cellTexts={cellTexts}
      noteTexts={noteTexts}
      showPopUp={showPopUp}
      cellAlign={cellAlign}
    />
  );
};

export default ProblemRow;
